import { apiRequest } from '../api/client';

export interface NotificationListItem {
  id: string;
  outboxId: string;
  channel: string;
  eventType: string;
  entityType: string;
  entityId: string;
  subject: string | null;
  body: string;
  status: string;
  sentAt: string | null;
  readAt: string | null;
  errorDetail: string | null;
  attempts: number;
  createdAt: string;
}

export interface NotificationListResult {
  items: NotificationListItem[];
  total: number;
  unreadCount: number;
}

/** Matches `apps/api` `GET /notifications`. */
export function fetchNotifications(limit: number, offset: number): Promise<NotificationListResult> {
  return apiRequest<NotificationListResult>(`/notifications?limit=${limit}&offset=${offset}`);
}

/** Matches `apps/api` `GET /notifications/unread-count`. */
export function fetchUnreadCount(): Promise<{ count: number }> {
  return apiRequest<{ count: number }>('/notifications/unread-count');
}

/** Matches `apps/api` `PATCH /notifications/:id`. */
export function markNotificationRead(id: string): Promise<{ id: string }> {
  return apiRequest<{ id: string }>(`/notifications/${id}`, { method: 'PATCH' });
}

export interface FailedNotificationsResult {
  items: NotificationListItem[];
  total: number;
}

/** Matches `apps/api` `GET /notifications/failed` (requires `notification.manage`). */
export function fetchFailedNotifications(
  limit: number,
  offset: number,
): Promise<FailedNotificationsResult> {
  return apiRequest<FailedNotificationsResult>(
    `/notifications/failed?limit=${limit}&offset=${offset}`,
  );
}

/** Matches `apps/api` `POST /notifications/outbox/:outboxId/retry`. */
export function retryOutboxNotification(outboxId: string): Promise<{ outboxId: string }> {
  return apiRequest<{ outboxId: string }>(`/notifications/outbox/${outboxId}/retry`, {
    method: 'POST',
  });
}

export interface NotificationPreferences {
  emailNonCriticalEnabled: boolean;
  inAppNonCriticalEnabled: boolean;
}

/** Matches `apps/api` `GET /settings/notifications/preferences`. */
export function fetchNotificationPreferences(): Promise<NotificationPreferences> {
  return apiRequest<NotificationPreferences>('/settings/notifications/preferences');
}

/** Matches `apps/api` `PUT /settings/notifications/preferences`. */
export function updateNotificationPreferences(
  input: Partial<NotificationPreferences>,
): Promise<NotificationPreferences> {
  return apiRequest<NotificationPreferences>('/settings/notifications/preferences', {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}
